export const iconFontAwesomeTravelHotelTruckField = (
	<i className="fa-solid fa-truck-field"></i>
);
